// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Container, Grid, Typography, Card, Stack } from '@mui/material';

// third party
import { motion } from 'framer-motion';

// icons
import BusinessIcon from '@mui/icons-material/Business';
import StorageIcon from '@mui/icons-material/Storage';
import SpeedIcon from '@mui/icons-material/Speed';
import GroupIcon from '@mui/icons-material/Group';

// ==============================|| LANDING - STATISTICS SECTION ||============================== //

const StatsSection = () => {
    const theme = useTheme();

    const stats = [
        {
            icon: <BusinessIcon sx={{ fontSize: 48 }} />,
            value: 1000,
            suffix: '+',
            label: 'Doanh nghiệp tin dùng',
            color: '#3B82F6'
        },
        {
            icon: <StorageIcon sx={{ fontSize: 48 }} />,
            value: 50,
            suffix: 'TB+',
            label: 'Dữ liệu được xử lý',
            color: '#8B5CF6'
        },
        {
            icon: <SpeedIcon sx={{ fontSize: 48 }} />,
            value: 99.9,
            suffix: '%',
            label: 'Uptime SLA',
            decimals: 1,
            color: '#10B981'
        },
        {
            icon: <GroupIcon sx={{ fontSize: 48 }} />,
            value: 10000,
            suffix: '+',
            label: 'Người dùng hoạt động',
            color: '#F59E0B'
        }
    ];

    return (
        <Box
            sx={{
                py: 10,
                background:
                    theme.palette.mode === 'dark'
                        ? 'linear-gradient(180deg, #0F172A 0%, #1E293B 100%)'
                        : 'linear-gradient(180deg, #F1F5F9 0%, #E2E8F0 100%)',
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            {/* Background decoration */}
            <Box
                sx={{
                    position: 'absolute',
                    top: -100,
                    right: -100,
                    width: 400,
                    height: 400,
                    borderRadius: '50%',
                    background:
                        theme.palette.mode === 'dark'
                            ? 'radial-gradient(circle, rgba(59,130,246,0.1) 0%, transparent 70%)'
                            : 'radial-gradient(circle, rgba(59,130,246,0.05) 0%, transparent 70%)'
                }}
            />

            <Container>
                <motion.div
                    initial={{ opacity: 0, translateY: 20 }}
                    whileInView={{ opacity: 1, translateY: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                >
                    <Stack spacing={2} alignItems="center" sx={{ mb: 8 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                color: theme.palette.primary.main,
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                letterSpacing: 1.5
                            }}
                        >
                            Thống kê ấn tượng
                        </Typography>
                        <Typography
                            variant="h2"
                            align="center"
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }
                            }}
                        >
                            Con số nói lên tất cả
                        </Typography>
                    </Stack>
                </motion.div>

                <Grid container spacing={4}>
                    {stats.map((stat, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <motion.div
                                initial={{ opacity: 0, scale: 0.5 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                            >
                                <Card
                                    sx={{
                                        p: 4,
                                        height: '100%',
                                        textAlign: 'center',
                                        background: theme.palette.mode === 'dark' ? 'rgba(30, 41, 59, 0.5)' : 'rgba(255, 255, 255, 0.9)',
                                        backdropFilter: 'blur(10px)',
                                        border: '1px solid',
                                        borderColor:
                                            theme.palette.mode === 'dark' ? 'rgba(148, 163, 184, 0.1)' : 'rgba(148, 163, 184, 0.2)',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            transform: 'translateY(-10px)',
                                            boxShadow:
                                                theme.palette.mode === 'dark'
                                                    ? '0 20px 40px rgba(0,0,0,0.3)'
                                                    : '0 20px 40px rgba(0,0,0,0.1)',
                                            borderColor: stat.color,
                                            '& .stat-icon': {
                                                transform: 'scale(1.2) rotate(10deg)',
                                                color: stat.color
                                            },
                                            '& .stat-value': {
                                                color: stat.color
                                            }
                                        }
                                    }}
                                >
                                    <Box
                                        className="stat-icon"
                                        sx={{
                                            color: theme.palette.text.secondary,
                                            mb: 2,
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        {stat.icon}
                                    </Box>
                                    <Typography
                                        variant="h2"
                                        className="stat-value"
                                        sx={{
                                            fontWeight: 700,
                                            mb: 1,
                                            transition: 'color 0.3s ease'
                                        }}
                                    >
                                        {stat.value}
                                        {stat.suffix}
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        {stat.label}
                                    </Typography>
                                </Card>
                            </motion.div>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default StatsSection;
